/**
 * App data
 */

export const Store = {
  inactivityTimeout: 20000,
  accountType: "guest",
  channelToChange: "",
  radiostations: {},
  activeRadiostationIndex: 0,
  focusedRadiostationIndex: 0,
};
